import { isPointsGroup } from "./isPointsGroup"

export const getHelmetTale = () => {
  return isPointsGroup() ? 'Prizma' : 'Aizek'
}